import NavButtons from 'components/Indoor_Cameras/IN-6012_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};